import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuLink } from '@common-modules/navigation/models/menu-link';
import { ModuleLink } from '@common-modules/navigation/models/module-link';

@Component({
    selector: 'wlm-module-menu-link',
    templateUrl: './module-link-menu.component.html',
    styleUrls: ['./module-link-menu.component.scss'],
    standalone: false
})
export class ModuleLinkMenuComponent implements OnInit {
  @Input() moduleLink: ModuleLink;

  constructor(private _router: Router) {}

  ngOnInit(): void {}

  public navigate(menuLink: MenuLink) {
    this._router.navigateByUrl(menuLink.urlPath);
  }
}
